//components
import { Popover } from "@material-ui/core";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
// style ( ******and in globalStyles.css *****)
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
  info: {
    fontSize: 13,
    MaxWidth: 500,
  },
  popover: {
    pointerEvents: "none",
  },
}));

function InputHeader({ info }) {
  const classes = useStyle();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <span>
      <ContactSupportIcon
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      ></ContactSupportIcon>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className={classes.info}>{info}</div>
      </Popover>
    </span>
  );
}

export default InputHeader;
